import '@treasury/domain-components/login/components/forgot-password';
import { TmBaseComponent } from '@treasury/presentation/tm-base.component';
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import '../components/logo/tm-bo-logo.component';

export const TM_BO_FORGOT_PASSWORD_TAG_NAME = 'tm-bo-forgot-password';

@customElement(TM_BO_FORGOT_PASSWORD_TAG_NAME)
export class ForgotPasswordContainer extends TmBaseComponent {
    public render() {
        return html`<forgot-password>
            <tm-bo-logo slot="default-logo"></tm-bo-logo>
        </forgot-password>`;
    }
}
